import Details from '../../../components/Details/Details'

export default function Accordions (props = {
    heading: null,
    items: null
}) {
    const items = Array.isArray(props.items)
        ? props.items
            .filter(obj => obj.summary
                && obj.text)
        : []

    if (!items.length)
        return null

    return (
        <section className="accordions pad-section">
            <div className="container">
                <div className="row flex-justify-content-center">
                    <div className="col-12 col-10-lg col-8-xl-up margin-2-b-neg">
                        {props.heading
                            && (
                                <h2 className="margin-3-b margin-5-b-lg-up text-align-center">
                                    {props.heading}
                                </h2>)}
                        {items
                            .map((obj, idx) => (
                                <Details
                                    className="card-border margin-b"
                                    key={`accordions-${idx}`}
                                    summary={obj.summary}
                                    text={obj.text}
                                />
                            ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
